module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return ((this.markers && this.markers.length && this.markers[0]) || this.noEmptyMessage) ? _c('div', [_c('div', {
    attrs: {
      "id": "osm"
    }
  })]) : _c('div', {
    staticClass: "text-center"
  }, [_vm._v("\n  No coordinates available\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3774aa5c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Map.vue
// module id = 434
// module chunks = 1